// Core
import React, { useState, useEffect } from 'react';
import { Text, useColorModeValue } from '@chakra-ui/react';

// Assets
import { numdownTimer } from 'services/Utils';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';

const Numdown = ({ endDate, declareDate, timeLeft, setTimeLeft }) => {

    useEffect(() => {
        const stopTimer = numdownTimer(endDate ?? declareDate, setTimeLeft);
        return stopTimer; 
    }, [endDate ?? declareDate]);

    return (
    	<Text variant="header" fontSize={{ base: '200px', md: '320px'}} lineHeight="50%">
    		{timeLeft ? timeLeft : new Date(declareDate) > new Date() ? '0' : '0'}
    	</Text>
   	);
};

export default Numdown;